import { render, staticRenderFns } from "./club-competitions.vue?vue&type=template&id=5e63b22a&scoped=true&"
import script from "./club-competitions.vue?vue&type=script&lang=ts&"
export * from "./club-competitions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63b22a",
  null
  
)

export default component.exports